import { AuthenticatedFileDownload } from '@eggplant/data-request'
import { MODELER_SERVICE } from '@eggplant/api-hosts'
import { useGetParamsWithSpaceId } from '../useGetParamsWithSpaceId'

interface Props {
  onSuccess: () => void
}

const DownloadTestCasesRequest = ({
  onSuccess
}: Props) => {
  const url = `${MODELER_SERVICE}/test_cases_export`

  const { requestParams } = useGetParamsWithSpaceId({})

  return (
    <AuthenticatedFileDownload
      fileType='text/csv'
      filename='testCaseList.csv'
      onSuccess={onSuccess}
      params={requestParams}
      url={url}
    />
  )
}

export default DownloadTestCasesRequest
